<div class="container container-wrapper">
  <div class="row justify-content-center">
    <section class="col-12 col-xl-11">
      <h3>{{ 'IMPRESSUM_HEAD' | translate }}</h3>
    </section>
  </div>
  <div class="row justify-content-center">
    <section class="col-12 col-xl-11">
      <app-text-block [prefix]="'IMPRESSUM'" [index]="1"></app-text-block>
    </section>
  </div>
</div>
